"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports.default = {
  name: 'CreateVarietyModal',
  components: {},
  props: {
    isModalActive: {
      type: Boolean,
      default: false
    },
    isSaving: {
      type: Boolean,
      default: false
    }
  },
  emits: ['submit', 'onClose'],
  data: function data() {
    var TYPE_OPTIONS = [{
      value: 'rootstock',
      label: 'Porta-enxerto'
    }, {
      value: 'scion',
      label: 'Enxerto'
    }];
    return {
      typeOptions: TYPE_OPTIONS,
      form: this.createDefaultForm(TYPE_OPTIONS)
    };
  },
  watch: {
    isModalActive: function isModalActive(active) {
      if (active) {
        this.resetForm();
      }
    }
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)({
    farm: 'GET_FARM'
  })),
  methods: {
    createDefaultForm: function createDefaultForm() {
      var _typeOptions$0$value, _typeOptions$;
      var typeOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.typeOptions;
      var defaultType = Array.isArray(typeOptions) ? (_typeOptions$0$value = (_typeOptions$ = typeOptions[0]) === null || _typeOptions$ === void 0 ? void 0 : _typeOptions$.value) !== null && _typeOptions$0$value !== void 0 ? _typeOptions$0$value : null : null;
      return {
        name: '',
        type: defaultType
      };
    },
    resetForm: function resetForm() {
      this.form = this.createDefaultForm();
    },
    handleClose: function handleClose() {
      this.resetForm();
      this.$emit('onClose');
    },
    submitForm: function submitForm() {
      var _this$farm;
      var name = this.form.name.trim();
      var type = this.form.type;
      if (!name) {
        this.$buefy.toast.open({
          message: 'Informe o nome da variedade.',
          type: 'is-danger'
        });
        return;
      }
      if (!type) {
        this.$buefy.toast.open({
          message: 'Selecione o tipo da variedade.',
          type: 'is-danger'
        });
        return;
      }
      var payload = {
        name: name,
        type: type,
        farmId: (_this$farm = this.farm) === null || _this$farm === void 0 ? void 0 : _this$farm.id
      };
      this.$emit('submit', payload);
    }
  }
};